import { render, staticRenderFns } from "./admin_forum.vue?vue&type=template&id=51aa4775&scoped=true&"
import script from "./admin_forum.vue?vue&type=script&lang=js&"
export * from "./admin_forum.vue?vue&type=script&lang=js&"
import style0 from "./admin_forum.vue?vue&type=style&index=0&id=51aa4775&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aa4775",
  null
  
)

export default component.exports